// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"764689e7","821":"b9eed332"}[chunkId] + ".chunk.js";
};